import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { getSDM20LHTs } from '../../data/SDM20LHT/actions';

class SDM20LHT extends Component {
    static propTypes = {
        initialized: PropTypes.bool.isRequired,
        getSDM20LHTs: PropTypes.func.isRequired,
        SDM20LHTs: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshSDM20LHTs();
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `SDM20LHT/detail/${rowData.id}` });
    };

    /* ACTIONS */
    refreshSDM20LHTs = () => {
        const { getSDM20LHTs } = this.props;
        this.setState({ loading: true });
        return getSDM20LHTs()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    /* RENDER */
    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRight = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`general.products.SDM20LHT.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshSDM20LHTs
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('SDM20LHTDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(SDM20LHTs => {
        let result = [];
        SDM20LHTs.map(SDM20LHT => {
            result.push({
                id: SDM20LHT.get('macAddress'),
                macAddress: SDM20LHT.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                addressIp: SDM20LHT.get('addressIp'),
                email: SDM20LHT.get('userEmail'),
                label: SDM20LHT.get('label'),
                state: SDM20LHT.getIn(['state'], false) ? Translator.translate(`general.${SDM20LHT.get('state')}`) : null,
                firmwareVersion: SDM20LHT.get('firmwareVersion'),
                usersList: SDM20LHT.get('usersList'),
                userMasterId: SDM20LHT.get('userMasterId')
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM20LHTDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });
    render() {
        const { loading } = this.state;
        const { profile, SDM20LHTs } = this.props;

        return (
            <FHETable
                idTable="SDM20LHTList"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM20LHTs)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`general.products.SDM20LHT.table.title`)}
                emptyDataSourceMessage={Translator.translate(`general.products.SDM20LHT.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const users = state.environments[history.environment].data.Users.get('list');
    let SDM20LHTs = state.environments[history.environment].data.SDM20LHT.get('list');
    SDM20LHTs = SDM20LHTs.map(SDM20LHT => {
        const masterId = SDM20LHT.getIn(['userMasterId'], '');
        return SDM20LHT.setIn(['userEmail'], users.getIn([masterId && masterId.toString(), 'email'], ''));
    });

    return {
        profile: state.data.user,
        SDM20LHTs,
        initialized: state.environments[history.environment].data.SDM20LHT.get('initialized')
    };
}
const styles = theme => ({
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getSDM20LHTs }, dispatch)
    )(withStyles(styles, { withTheme: true })(SDM20LHT))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/SDM20LHT/index.js